import { Box, Typography } from "@mui/material";
import { FaBoxOpen, FaHome } from "react-icons/fa";

const Sidebar = () => {
  return (
    <Box
      sx={{ width: 240 }}
      className="bg-white shadow-lg hidden md:block"
    >
      <div className="p-6 border-b">
        <Typography variant="h6" fontWeight="bold">
          Admin Panel
        </Typography>
      </div>

      <div className="p-4 space-y-4">
        <div className="flex items-center gap-3 cursor-pointer hover:text-blue-600">
          <FaHome />
          <span>Dashboard</span>
        </div>

        <div className="flex items-center gap-3 cursor-pointer hover:text-blue-600">
          <FaBoxOpen />
          <span>Products</span>
        </div>
      </div>
    </Box>
  );
};

export default Sidebar;
